module.exports = __webpack_public_path__ + "img/banner-helal.593477a.webp";